/* ============================================================
   Lululi Kids: experiências do site (celular primeiro)

   1) "Pra quem é?": perfil da criança (nome, idade, altura opcional,
      irmãos) salvo só neste aparelho. Personaliza a saudação e marca
      o tamanho recomendado nos cartões e na ficha. Sem perfil, nada
      vem marcado.
   2) Ficha: nenhum tamanho pré-marcado sem perfil; o botão de compra
      pede o tamanho. Régua da porta sugere o tamanho pela altura.
      Aviso do kit aparece nas cores femininas da blusa.
   3) Sacola: "É presente?" vira atributo do carrinho + mensagem.
   4) Livro de virar: faixas que deslizam e "Levar tudo".
   5) "Chega até DD/MM" a partir do prazo em dias úteis.

   Regras (frete, Pix, parcelas, prazo, tabela de tamanhos) vêm de
   snippets/lululi-regras.liquid, que lê as configurações do tema.
   ============================================================ */
(function () {
  var R = Object.assign(
    { freteGratis: 29900, frete: 2490, pix: 5, parcelas: 3, diasUteis: 10, tabela: '1:80, 2:92, 4:104, 6:116, 8:128, 10:140' },
    (typeof window !== 'undefined' && window.Lululi && window.Lululi.regras) || {}
  );

  // ---------- contas (sem DOM: testadas em scripts/teste-lululi.js) ----------
  function brl(centavos) {
    var v = (Math.round(centavos) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }

  var TABELA = String(R.tabela)
    .split(',')
    .map(function (x) { return x.split(':').map(function (s) { return s.trim(); }); })
    .filter(function (p) { return p[0] && +p[1] > 0; })
    .map(function (p) { return { t: p[0], max: +p[1] }; })
    .sort(function (a, b) { return a.max - b.max; });

  function tamanhoPorAltura(h) {
    h = +h;
    if (!TABELA.length || !(h > 0)) return null;
    for (var i = 0; i < TABELA.length; i++) if (h <= TABELA[i].max) return TABELA[i].t;
    return TABELA[TABELA.length - 1].t;
  }

  // ponytail: sem altura, tamanho pela idade (tamanho infantil acompanha a idade); a altura manda quando existe
  function tamanhoPorIdade(idade) {
    idade = +idade;
    if (!(idade >= 0)) return null;
    var nums = TABELA.map(function (z) { return +z.t; }).filter(function (n) { return !isNaN(n); });
    if (!nums.length) return null;
    var alvo = Math.max(1, Math.ceil(idade));
    for (var i = 0; i < nums.length; i++) if (nums[i] >= alvo) return String(nums[i]);
    return String(nums[nums.length - 1]);
  }

  function tamanhoDe(c) {
    if (!c) return null;
    return tamanhoPorAltura(c.altura) || tamanhoPorIdade(c.idade);
  }

  // ponytail: dias úteis = seg a sex, sem feriados; somar feriados quando o prazo apertar
  function dataEntrega(base) {
    var d = new Date(base || Date.now());
    var n = R.diasUteis;
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  function ddmm(d) {
    return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0');
  }

  // poncho e outros com P/M: P até o tamanho 4, M acima
  function tamanhoNaGrade(tam, valores) {
    if (!tam) return null;
    if (valores.indexOf(tam) >= 0) return tam;
    if (valores.indexOf('P') >= 0 && valores.indexOf('M') >= 0) return +tam <= 4 ? 'P' : 'M';
    return null;
  }

  var util = { brl: brl, tamanhoPorAltura: tamanhoPorAltura, tamanhoPorIdade: tamanhoPorIdade, tamanhoDe: tamanhoDe, dataEntrega: dataEntrega, ddmm: ddmm, tamanhoNaGrade: tamanhoNaGrade };
  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = util;
    return;
  }
  window.Lululi = window.Lululi || {};
  window.Lululi.util = util;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // só escreve quando muda: o observador da ficha não pode entrar em laço
  function texto(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function html(el, s) { if (el && el.innerHTML !== s) el.innerHTML = s; }

  // ---------- perfil ----------
  var CHAVE = 'lululi-perfil';
  function lerPerfil() {
    try {
      var p = JSON.parse(localStorage.getItem(CHAVE));
      if (p && Array.isArray(p.criancas) && p.criancas.length) {
        var cs = p.criancas.slice(0, 6).filter(function (c) { return c && c.nome; });
        if (cs.length) return { criancas: cs, ativa: Math.min(Math.max(p.ativa | 0, 0), cs.length - 1) };
      }
    } catch (e) {}
    return null;
  }
  var perfil = lerPerfil();
  function salvarPerfil(p) {
    perfil = p;
    try {
      if (p) localStorage.setItem(CHAVE, JSON.stringify(p));
      else localStorage.removeItem(CHAVE);
    } catch (e) {}
    aplicar();
  }
  function ativa() { return perfil ? perfil.criancas[perfil.ativa] : null; }
  function daDo(nome) { return /a$/i.test(nome) ? 'dela' : 'dele'; }

  // ---------- personalização ----------
  function aplicar() {
    var c = ativa();
    var t = tamanhoDe(c);

    $$('[data-lululi-saudacao]').forEach(function (el) {
      if (el.dataset.original == null) el.dataset.original = el.textContent.trim();
      el.textContent = c ? 'Oi, ' + c.nome + ' ;)' : el.dataset.original;
    });
    $$('[data-lululi-sub]').forEach(function (el) {
      if (el.dataset.original == null) el.dataset.original = el.textContent.trim();
      el.textContent = c && t ? 'Tamanho ' + t + '. As peças que têm o tamanho ' + daDo(c.nome) + ' aparecem marcadas.' : el.dataset.original;
    });
    $$('[data-lululi-criancas]').forEach(function (el) {
      el.textContent = '';
      el.hidden = !perfil;
      if (!perfil) return;
      perfil.criancas.forEach(function (k, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lululi-crianca';
        b.setAttribute('aria-pressed', String(i === perfil.ativa));
        b.dataset.lululiAtivar = i;
        b.textContent = k.nome + ' · tam. ' + tamanhoDe(k);
        el.appendChild(b);
      });
      var mais = document.createElement('button');
      mais.type = 'button';
      mais.className = 'lululi-crianca lululi-crianca--mais';
      mais.setAttribute('data-lululi-perfil-abrir', '');
      mais.textContent = 'Editar';
      el.appendChild(mais);
    });
    $$('[data-lululi-titulo-tamanho]').forEach(function (el) {
      if (el.dataset.original == null) el.dataset.original = el.textContent.trim();
      el.textContent = t ? 'No tamanho ' + t : el.dataset.original;
    });
    $$('[data-lululi-card]').forEach(function (card) {
      var fit = $('[data-lululi-fit]', card);
      if (!fit) return;
      var idx = card.dataset.lululiCrianca;
      var k = idx != null && perfil && perfil.criancas.length > 1 ? perfil.criancas[+idx] || c : c;
      var tk = tamanhoDe(k);
      var grade = (card.dataset.tamanhos || '').split(',').filter(Boolean);
      var tg = tamanhoNaGrade(tk, grade);
      fit.hidden = !tk || !grade.length;
      fit.classList.toggle('is-sem', !tg);
      var quem = idx != null && perfil && perfil.criancas.length > 1 ? k.nome + ' · ' : '';
      fit.textContent = tg ? quem + 'tam. ' + tg : quem + 'sem o tam. ' + tk;
    });
    $$('[data-lululi-irmaos-texto]').forEach(function (el) {
      if (el.dataset.original == null) el.dataset.original = el.textContent.trim();
      var cs = perfil ? perfil.criancas : [];
      el.textContent = cs.length > 1 ? 'Mesma praia pra ' + cs[1].nome + ' e ' + cs[0].nome + '. Cada um no seu tamanho, numa sacola só.' : el.dataset.original;
    });
    ficha();
    $$('[data-lululi-livro]').forEach(function (el) { if (el._atualizar) el._atualizar(true); });
  }

  // ---------- janela "Pra quem é?" ----------
  var editando = 0;
  function janela() { return $('#lululi-perfil'); }
  function preencher(form, c) {
    form.nome.value = c ? c.nome : '';
    $$('input[name="idade"]', form).forEach(function (r) { r.checked = !!c && +r.value === +c.idade; });
    form.altura.value = c && c.altura ? c.altura : '';
    $('[data-lululi-perfil-erro]', form).textContent = '';
  }
  function desenharLista(form) {
    var ul = $('[data-lululi-perfil-lista]', form);
    ul.textContent = '';
    var cs = perfil ? perfil.criancas : [];
    ul.hidden = !cs.length;
    cs.forEach(function (c, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lululi-crianca';
      b.setAttribute('aria-pressed', String(i === editando));
      b.dataset.lululiEditar = i;
      b.textContent = c.nome;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'lululi-crianca__tirar';
      x.dataset.lululiTirar = i;
      x.setAttribute('aria-label', 'Tirar ' + c.nome);
      x.textContent = '×';
      li.appendChild(b);
      li.appendChild(x);
      ul.appendChild(li);
    });
    $('[data-lululi-perfil-mais]', form).hidden = !cs.length || cs.length >= 6;
    $('[data-lululi-perfil-apagar]', form).hidden = !cs.length;
  }
  function abrirPerfil() {
    var dlg = janela();
    if (!dlg) return;
    var form = $('form', dlg);
    editando = perfil ? perfil.ativa : 0;
    preencher(form, ativa());
    desenharLista(form);
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    form.nome.focus();
  }
  function fecharPerfil() {
    var dlg = janela();
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-lululi-perfil-form]');
    if (!form) return;
    e.preventDefault();
    var erro = $('[data-lululi-perfil-erro]', form);
    var nome = form.nome.value.trim().slice(0, 20);
    var idade = $('input[name="idade"]:checked', form);
    var altura = parseInt(form.altura.value, 10);
    if (!nome) { erro.textContent = 'Escreva o nome.'; form.nome.focus(); return; }
    if (!idade) { erro.textContent = 'Escolha a idade.'; return; }
    if (form.altura.value && !(altura >= 45 && altura <= 160)) { erro.textContent = 'A altura vai de 45 a 160 cm.'; form.altura.focus(); return; }
    var cs = perfil ? perfil.criancas.slice() : [];
    var c = { nome: nome, idade: +idade.value, altura: altura >= 45 ? altura : null };
    if (editando >= cs.length) cs.push(c);
    else cs[editando] = c;
    salvarPerfil({ criancas: cs, ativa: Math.min(editando, cs.length - 1) });
    fecharPerfil();
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-lululi-perfil-abrir]')) { e.preventDefault(); abrirPerfil(); return; }
    if (t.closest('[data-lululi-perfil-fechar]')) { fecharPerfil(); return; }
    var ativar = t.closest('[data-lululi-ativar]');
    if (ativar && perfil) { salvarPerfil({ criancas: perfil.criancas, ativa: +ativar.dataset.lululiAtivar }); return; }
    var form = t.closest('[data-lululi-perfil-form]');
    if (!form) {
      if (t === janela()) fecharPerfil(); // toque fora da caixa
      return;
    }
    var ed = t.closest('[data-lululi-editar]');
    if (ed) { editando = +ed.dataset.lululiEditar; preencher(form, perfil.criancas[editando]); desenharLista(form); return; }
    var tirar = t.closest('[data-lululi-tirar]');
    if (tirar && perfil) {
      var cs = perfil.criancas.slice();
      cs.splice(+tirar.dataset.lululiTirar, 1);
      salvarPerfil(cs.length ? { criancas: cs, ativa: 0 } : null);
      editando = 0;
      preencher(form, ativa());
      desenharLista(form);
      return;
    }
    if (t.closest('[data-lululi-perfil-mais]')) { editando = perfil ? perfil.criancas.length : 0; preencher(form, null); desenharLista(form); form.nome.focus(); return; }
    if (t.closest('[data-lululi-perfil-apagar]')) { salvarPerfil(null); fecharPerfil(); }
  });

  // ---------- ficha: tamanho escolhido de verdade ----------
  var escolhidos = {}; // id do produto -> tamanho que o cliente tocou (ou o do perfil)
  var preTentado = {};
  var SEM = 'data-lululi-sem-tamanho';
  var ehTamanho = function (i) { return i && i.getAttribute && i.getAttribute('data-option-name') === 'Tamanho'; };
  var idDe = function (el) { var p = el.closest('variant-picker[data-product-id]'); return p ? p.dataset.productId : null; };
  function fieldsetsTamanho(raiz) {
    return $$('variant-picker[data-product-id] fieldset', raiz).filter(function (f) { return f.querySelector('input[data-option-name="Tamanho"]'); });
  }

  (function () {
    if (!new URLSearchParams(location.search).has('variant')) return;
    var fs = fieldsetsTamanho($('main') || document)[0];
    var m = fs && fs.querySelector('input:checked');
    if (m) escolhidos[idDe(fs)] = m.value;
  })();

  function ficha() {
    var c = ativa();
    var tRec = tamanhoDe(c);
    fieldsetsTamanho().forEach(function (fs) {
      var id = idDe(fs);
      var inputs = $$('input[data-option-name="Tamanho"]', fs);
      var valores = inputs.map(function (i) { return i.value; });
      var rec = tamanhoNaGrade(tRec, valores);
      inputs.forEach(function (i) { var l = i.closest('label'); if (l) l.classList.toggle('lululi-rec', i.value === rec); });

      // com perfil, o tamanho dele já vem marcado (uma vez por produto)
      // só depois do seletor do tema ligado: antes disso o clique não troca a variante do botão
      if (rec && !escolhidos[id] && !preTentado[id] && window.customElements && customElements.get('variant-picker')) {
        preTentado[id] = true;
        var alvo = inputs.filter(function (i) { return i.value === rec && i.dataset.optionAvailable !== 'false'; })[0];
        if (alvo) {
          escolhidos[id] = rec;
          if (!alvo.checked) { alvo.click(); return; }
        }
      }
      var marcado = fs.querySelector('input:checked');
      var falta = !marcado || escolhidos[id] !== marcado.value;
      if (falta && marcado) marcado.checked = false; // o leitor de tela não anuncia um tamanho que ninguém escolheu
      fs.toggleAttribute(SEM, falta);
      if (!falta) { var av = fs.parentElement && fs.parentElement.querySelector('.lululi-aviso-tamanho'); if (av) av.remove(); }
    });
    regua();
    kit();
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('label');
    var input = (label && label.querySelector('input[type="radio"]')) || e.target;
    if (!ehTamanho(input)) return;
    var id = idDe(input);
    if (!id) return;
    escolhidos[id] = input.value;
    requestAnimationFrame(ficha);
  }, true);

  function pedirTamanho(fs) {
    var aviso = fs.parentElement.querySelector('.lululi-aviso-tamanho');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = 'lululi-aviso-tamanho';
      aviso.setAttribute('role', 'alert');
      aviso.textContent = 'Escolha o tamanho antes de pôr na sacola.';
      fs.insertAdjacentElement('afterend', aviso);
    }
    fs.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    var primeiro = fs.querySelector('input:not([aria-disabled="true"])');
    if (primeiro) primeiro.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('[ref="addToCartButton"], .add-to-cart-button, .sticky-add-to-cart__button');
    if (!botao) return;
    var dono = botao.closest('product-form-component[data-product-id], sticky-add-to-cart[data-product-id]');
    var id = dono && dono.dataset.productId;
    if (!id) return;
    var fs = null;
    for (var el = botao.parentElement; el && !fs; el = el.parentElement) {
      var picker = el.querySelector('variant-picker[data-product-id="' + id + '"]');
      if (picker) fs = fieldsetsTamanho(picker)[0] || null;
    }
    if (!fs) return;
    ficha();
    if (!fs.hasAttribute(SEM)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pedirTamanho(fs);
  }, true);

  // ---------- régua da porta ----------
  function regua() {
    $$('[data-lululi-regua]').forEach(function (box) {
      var range = $('[data-lululi-altura]', box);
      if (!range) return;
      if (!box._pronto) {
        box._pronto = true;
        var c = ativa();
        if (c && c.altura) range.value = c.altura;
        range.addEventListener('input', function () { box._avisoEstoque = false; desenharRegua(box); });
        $('[data-lululi-usar]', box).addEventListener('click', function () { usarTamanho(box); });
      }
      var k = ativa();
      var resumo = $('[data-lululi-regua-resumo]', box);
      var tk = tamanhoDe(k);
      texto(resumo, k && tk ? 'Pelo perfil de ' + k.nome + ': tamanho ' + tk : '');
      desenharRegua(box);
    });
  }
  function desenharRegua(box) {
    var range = $('[data-lululi-altura]', box);
    var h = +range.value;
    var min = +range.min, max = +range.max;
    $('[data-lululi-marca]', box).style.bottom = ((h - min) / (max - min)) * 100 + '%';
    texto($('[data-lululi-altura-valor]', box), h + ' cm');
    var t = tamanhoPorAltura(h);
    var z = TABELA.filter(function (x) { return x.t === t; })[0];
    var acima = z && h > z.max;
    if (!box._avisoEstoque) {
      html($('[data-lululi-regua-res]', box), t
        ? 'Tamanho <b>' + t + '</b><small>' + (acima ? 'maior que a nossa tabela' : 'serve até ' + z.max + ' cm') + '</small>'
        : '');
    }
    var usar = $('[data-lululi-usar]', box);
    usar.dataset.tamanho = t || '';
    texto(usar, t ? 'Usar o tamanho ' + t : 'Usar este tamanho');
  }
  function usarTamanho(box) {
    var t = $('[data-lululi-usar]', box).dataset.tamanho;
    var fs = fieldsetsTamanho($('main') || document)[0];
    if (!fs || !t) return;
    var input = fs.querySelector('input[data-option-name="Tamanho"][value="' + t + '"]');
    var res = $('[data-lululi-regua-res]', box);
    if (!input || input.dataset.optionAvailable === 'false') {
      box._avisoEstoque = true;
      html(res, 'Tamanho <b>' + t + '</b><small>sem estoque nesta cor agora</small>');
      return;
    }
    escolhidos[idDe(fs)] = t;
    (input.closest('label') || input).click();
    fs.scrollIntoView({ block: 'center' });
  }

  // ---------- aviso do kit (cores femininas da blusa) ----------
  function kit() {
    $$('[data-lululi-kit]').forEach(function (a) {
      var cores = (a.dataset.cores || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var marcada = $('main variant-picker input[data-option-name="Cor"]:checked');
      var cor = marcada ? marcada.value : (($('main [data-testid="variant-option-single-value"]') || {}).textContent || '');
      cor = cor.toLowerCase();
      a.hidden = !cores.some(function (c) { return cor.indexOf(c) >= 0; });
    });
  }

  // ---------- sacola: presente ----------
  var tempoPresente = null;
  function salvarPresente(box) {
    var ck = $('[data-lululi-presente]', box);
    var msg = $('[data-lululi-mensagem]', box);
    var sim = !!(ck && ck.checked);
    var texto = sim && msg ? msg.value.trim().slice(0, 200) : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { Presente: sim ? 'Sim' : '', 'Mensagem do cartão': texto },
        note: sim ? 'Presente.' + (texto ? ' Cartão: ' + texto : '') : '',
      }),
    }).catch(function () {
      var p = box.querySelector('small');
      if (p) p.textContent = 'Não deu para salvar agora. Tente de novo.';
    });
  }
  document.addEventListener('change', function (e) {
    var ck = e.target.closest && e.target.closest('[data-lululi-presente]');
    if (ck) {
      var box = ck.closest('.lululi-presente');
      var cartao = $('.lululi-presente__cartao', box);
      if (cartao) cartao.hidden = !ck.checked;
      salvarPresente(box);
      return;
    }
    if (e.target.closest && e.target.closest('main variant-picker')) requestAnimationFrame(ficha);
  });
  document.addEventListener('input', function (e) {
    var msg = e.target.closest && e.target.closest('[data-lululi-mensagem]');
    if (!msg) return;
    clearTimeout(tempoPresente);
    tempoPresente = setTimeout(function () { salvarPresente(msg.closest('.lululi-presente')); }, 600);
  });

  // ---------- livro de virar ----------
  function iniciarLivro(el) {
    var paginas = $$('[data-lululi-pagina]', el);
    if (!paginas.length) return;
    var pos = paginas.map(function () { return 0; });
    var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tamanho = null;

    function itens(pg) { return $$('.lululi-pagina__item', pg); }
    function variante(item) {
      if (item.hasAttribute('data-sem')) return null;
      var nomes = JSON.parse(item.dataset.opcoes || '[]');
      var vars = JSON.parse(item.dataset.variantes || '[]');
      var iT = nomes.indexOf('Tamanho');
      if (iT < 0) return vars.filter(function (v) { return v.ok; })[0] || null;
      var grade = vars.map(function (v) { return v.o[iT]; });
      var alvo = tamanhoNaGrade(tamanho, grade);
      return vars.filter(function (v) { return v.ok && v.o[iT] === alvo; })[0] || null;
    }
    function atualizar(doPerfil) {
      if (doPerfil) {
        var t = tamanhoDe(ativa());
        var radio = t && el.querySelector('[data-lululi-livro-tam][value="' + t + '"]');
        if (radio && !tamanho) { radio.checked = true; tamanho = t; }
        var lead = $('[data-lululi-livro-lead]', el);
        var c = ativa();
        if (lead && c && t) lead.textContent = 'Kit de praia de ' + c.nome + ', tamanho ' + t + '. Arraste cada faixa para o lado.';
      }
      var total = 0;
      paginas.forEach(function (pg, i) {
        var item = itens(pg)[pos[i]];
        var rot = $('[data-lululi-rotulo]', pg);
        if (!item || item.hasAttribute('data-sem')) { rot.textContent = 'Sem saída de praia'; return; }
        var preco = +item.dataset.preco || 0;
        total += preco;
        var falta = tamanho && !variante(item);
        rot.textContent = item.dataset.nome + ' · ' + brl(preco) + (falta ? ' · sem o tam. ' + tamanho : '');
        rot.classList.toggle('is-sem', !!falta);
      });
      $('[data-lululi-livro-total]', el).textContent = brl(total);
      $('[data-lululi-livro-pix]', el).textContent = brl((total * (100 - R.pix)) / 100) + ' no Pix';
    }
    el._atualizar = atualizar;

    paginas.forEach(function (pg, i) {
      var trilho = $('[data-lululi-trilho]', pg);
      var tempo = null;
      trilho.addEventListener('scroll', function () {
        clearTimeout(tempo);
        tempo = setTimeout(function () {
          pos[i] = Math.round(trilho.scrollLeft / Math.max(1, trilho.clientWidth));
          atualizar();
        }, 80);
      });
      $$('[data-lululi-seta]', pg).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = itens(pg).length;
          pos[i] = (pos[i] + +b.dataset.lululiSeta + n) % n;
          trilho.scrollTo({ left: pos[i] * trilho.clientWidth, behavior: reduz ? 'auto' : 'smooth' });
          atualizar();
        });
      });
    });
    el.addEventListener('change', function (e) {
      if (e.target.matches('[data-lululi-livro-tam]')) { tamanho = e.target.value; atualizar(); }
    });

    var levar = $('[data-lululi-levar]', el);
    var aviso = $('[data-lululi-livro-aviso]', el);
    levar.addEventListener('click', async function () {
      if (!tamanho) {
        aviso.textContent = 'Escolha o tamanho lá em cima.';
        var f = el.querySelector('[data-lululi-livro-tam]');
        if (f) f.focus();
        return;
      }
      var ids = [];
      var sem = [];
      paginas.forEach(function (pg, i) {
        var item = itens(pg)[pos[i]];
        if (!item || item.hasAttribute('data-sem')) return;
        var v = variante(item);
        if (v) ids.push(v.id);
        else sem.push(item.dataset.nome);
      });
      if (!ids.length) { aviso.textContent = 'Nenhuma peça deste look tem o tamanho ' + tamanho + ' agora.'; return; }
      levar.disabled = true;
      levar.textContent = 'Pondo na sacola…';
      try {
        var acoes = window.Shopify && window.Shopify.actions;
        if (acoes && acoes.updateCart) {
          // ação de carrinho do tema: adiciona tudo numa chamada e atualiza gaveta e contador
          var r = await acoes.updateCart(
            { lines: ids.map(function (id) { return { merchandiseId: String(id), quantity: 1 }; }) },
            { event: { context: 'product' } }
          );
          if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
          if (acoes.openCart) acoes.openCart();
        } else {
          var resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }),
          });
          if (!resp.ok) throw new Error('add');
          location.href = '/cart';
          return;
        }
        aviso.textContent = sem.length ? 'Foi para a sacola. Ficou de fora, sem o tamanho ' + tamanho + ': ' + sem.join(', ') + '.' : 'Look na sacola.';
      } catch (err) {
        aviso.textContent = 'Não deu para pôr na sacola agora. Tente de novo.';
      }
      levar.disabled = false;
      levar.textContent = 'Levar tudo';
    });
    atualizar(true);
  }

  // ---------- início ----------
  function iniciar() {
    $$('[data-lululi-data]').forEach(function (el) { el.textContent = ddmm(dataEntrega()); });
    $$('[data-lululi-livro]').forEach(iniciarLivro);
    aplicar();
    if (window.customElements) customElements.whenDefined('variant-picker').then(function () { requestAnimationFrame(ficha); });
    // o tema redesenha o seletor ao trocar de cor ou abrir a compra rápida
    var agendado = null;
    new MutationObserver(function () {
      cancelAnimationFrame(agendado);
      agendado = requestAnimationFrame(ficha);
    }).observe($('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
